import { feedTypeInterface } from './interfaces';
export const FEED_TYPE: feedTypeInterface = Object.freeze({
  inTheVote: 0,
  approved: 1,
  toDelete: 2,
  deleted: 3,
  toEdit: 4,
  edited: 5,
  rejected: 6,
  history: 7,
  sectionApproved: 8,
  sectionEdited: 9,
  toEditSectionSuggestion: 10
});

export enum FEED_TYPE_STATIC {
  deleted = 3,
  approved = 8,
  edited = 9,
  rejected = 6,
}

export enum DYNAMIC_STATUS {
  inTheVote = 0,
  toDelete = 2,
  toEdit = 4,
  toEditInTheVote = 7,
  toEditSectionSuggestion = 10
}

export enum STATIC_STATUS {
  approved = 1,
  deleted = 3,
  edited = 5,
  sectionApproved = 8,
  sectionEdited = 9,
  rejected = 6,
}

export const SECTION_STATUS = Object.freeze({
  inTheVote: 0,
  approved: 1,
  toDelete: 2,
  deleted: 3,
  toEdit: 4,
  edited: 5,
  rejected: 6,
  toEditInTheVote: 7
});

export enum ROUTE_NAME {
  home = 'home',
  aboutConsenz = 'aboutConsenz',
  aboutDocument = 'aboutDocument',
  contactUs = 'contactUs',
  draft = 'draft',
  section = 'section',
  addNew = 'addNew',
  vote = 'vote',
  chooseTopics = 'choosetopics',
  welcome = 'welcome',
  usersList = 'usersList',
}

export enum SECTION_BY {
  sectionById = 'sectionById',
  sectionsByStatus = 'sectionsByStatus',
}

export enum NOTIFICATION_TYPE {
  vote = 'vote',
  argument = 'argument',
  section = 'section',
  comment = 'comment',
}

export enum NOTIFICATION_TRIGGER {
  argumentCreation, // Event: A new argument or comment is created
  sectionApproval, // Event: The section status changed to "approved"
  sectionEdit, // Event: A new edit section is created
  sectionCreation // Event: New section in document
}

export enum MAIL_RECIPIENT {
  voters = 'voters',
  owner = 'owner',
  participants = 'participants',
  responders = 'responders',
  subscribers = 'subscribers'
}

export enum VOTING_OPTIONS {
  pros = 'pros',
  cons = 'cons',
}

export enum ROLE {
  editor = 'editor',
}

export const EVENT_TYPE = Object.freeze({
  votedSuggestion: 'User Voted For Suggestion',
  addedArgument: 'User Added New Argument',
  addedComment: 'User Added New Comment',
  addedNewSuggestion: 'User Added New Section Suggestion',
  addedEditSuggestion: 'User Added New Edit Section Suggestion',
  acceptedNewSuggestion: 'New Section Suggestion Was Accepted',
  acceptedEditSuggestion: 'New Edit Section Suggestion Was Accepted',
  editedSuggestion: 'Editor/Admin User Edit a Section'
})
